/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

@Injectable()
export class LiftContainer {
  private container: HTMLElement;

  showOverlay(): void {
    this.getContainerElement().classList.add('raised');
  }

  hideOverlay(): void {
    this.getContainerElement().classList.remove('raised');
  }

  private getContainerElement(): HTMLElement {
    let { container } = this;

    if (!container) {
      this.container = container = document.createElement('div');
      container.classList.add('lift-container');
      document.body.appendChild(container);
    }

    return container;
  }
}
